<template>
  <div>
    <el-select
      :placeholder="$t('Seçin')"
      filterable
      :value="selected || null"
      @input="handleInput"
      style="width: 100%"
    >
      <el-option
        v-for="item in data"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { usersbyrole } from "../../services/sales";
export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      selected: this.value,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },
    getData() {
      usersbyrole(14).then((response) => {
        if (response.data) {
          this.data = response.data;
        } else {
          this.$message({
            type: "error",
            message: "Client service users: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>